import styled from 'styled-components';

export const SButtonsSection = styled.div`
  padding-top: 15px;
`;

export const SMessage = styled.div`
  font-size: ${({ theme }) => theme.text.size.mediumLarge};
  margin: 20px 0 25px;
`;

export const SHeading = styled.div`
  font-size: ${({ theme }) => theme.text.size.large};
  margin: 25px 0 40px;
`;
